import React from 'react';
import classNames from 'classnames';

export default function Formula({ formulaLines }) {
  return (
    <>
      {formulaLines.map((item, i) => (
        <span className={classNames(i === 0 && 'pr-0.5')} key={`${item}-${i}`}>
          {item}
        </span>
      ))}
    </>
  );
}
